import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield, ChevronDown, Lock } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Footer() {
  const [isDisclosureOpen, setIsDisclosureOpen] = useState(false);
  return <footer className="bg-[#050505] text-white border-t border-gray-800 relative overflow-hidden" data-id="element-2391" data-mp="3sneocwximamm">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] opacity-20 pointer-events-none" data-id="element-2392" data-mp="1hvfe1mw8pgt" />

      <div className="max-w-6xl mx-auto px-6 py-20 relative z-10" data-id="element-2393" data-mp="b87wfjvi20i7">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-2394" data-mp="g5q5da9iofq7">
          <div className="col-span-1 md:col-span-2 lg:col-span-2" data-id="element-2395" data-mp="k7lakpukjd99">
            <div className="flex items-center gap-3 mb-6" data-id="element-2396" data-mp="k9efo0pj9pf5">
              <div className="w-8 h-8 flex items-center justify-center bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-sm" data-id="element-2397" data-mp="p5wkf0kv5nrh">
                <Shield className="w-5 h-5 text-[#FF0000]" data-id="element-2398" data-mp="2iubhma9sskj5" />
              </div>
              <h3 className="text-lg font-black tracking-tight uppercase" data-id="element-2399" data-mp="2eq3p0207ykfn">
                ToxicDetector
              </h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs font-mono mb-8" data-id="element-2400" data-mp="29u6cy7vzo08o">
              AI-powered forensic toxicity detection for safer conversations. We
              help you see what's really happening.
            </p>

            {/* Calm Trust Strip */}
            <div className="inline-flex items-center gap-4 bg-[#0A0A0A] border border-gray-800 rounded-lg px-4 py-3" data-id="element-2401" data-mp="2xi6bhtzjkuxt">
              <div className="flex items-center gap-2" data-id="element-2402" data-mp="2sov0rhrlzu0m">
                <Lock className="w-3 h-3 text-gray-500" data-id="element-2403" data-mp="2nqtll7xb0euf" />
                <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-gray-500" data-id="element-2404" data-mp="3l78sczmcqjr9">
                  AES-256 ENCRYPTED
                </span>
              </div>
              <div className="h-3 w-px bg-gray-800" data-id="element-2405" data-mp="3gefmg8f5d5dl" />
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-gray-500" data-id="element-2406" data-mp="1eiqabod20aof">
                TRUSTED BY 10,000+ USERS
              </span>
            </div>
          </div>

          <div className="col-span-1 md:col-span-2 lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-8" data-id="element-2407" data-mp="14torzrj1dh7a">
            <div data-id="element-2408" data-mp="19rgkonri97cj">
              <h4 className="font-bold mb-6 text-xs uppercase tracking-widest text-white" data-id="element-2409" data-mp="19qyry141xb9d">
                Product
              </h4>
              <ul className="space-y-4 text-sm font-medium text-gray-400" data-id="element-2410" data-mp="uxc2z6yfrriv">
                <li data-id="element-2411" data-mp="zvnbneczvvzi">
                  <a href="/#features" className="hover:text-[#FF0000] transition-colors" data-id="element-2412" data-mp="zrpq6m2y2scg">
                    Features
                  </a>
                </li>
                <li data-id="element-2413" data-mp="2g8lmhgxzoym1">
                  <a href="/#pricing" className="hover:text-[#FF0000] transition-colors" data-id="element-2414" data-mp="2g82g8xhpbynu">
                    Pricing
                  </a>
                </li>
                <li data-id="element-2415" data-mp="2vc58xz73ktzx">
                  <a href="/#faq" className="hover:text-[#FF0000] transition-colors" data-id="element-2416" data-mp="2vblr0ihg65lw">
                    FAQ
                  </a>
                </li>
                <li data-id="element-2417" data-mp="345i83ivr8rug">
                  <Link to="/dashboard" className="hover:text-[#FF0000] transition-colors" data-id="element-2418" data-mp="2zd78yi8u9a2y">
                    Dashboard
                  </Link>
                </li>
              </ul>
            </div>

            <div data-id="element-2419" data-mp="392igw1jzo8p9">
              <h4 className="font-bold mb-6 text-xs uppercase tracking-widest text-white" data-id="element-2420" data-mp="3954izlo41w03">
                Corporate
              </h4>
              <ul className="space-y-4 text-sm font-medium text-gray-400" data-id="element-2421" data-mp="3j0oe45uuoqns">
                <li data-id="element-2422" data-mp="1so8pszod45uq">
                  <a href="/about" className="hover:text-[#FF0000] transition-colors" data-id="element-2423" data-mp="1snqlrgvgknc9">
                    The Lab
                  </a>
                </li>
                <li data-id="element-2424" data-mp="1q3apvg28ofnd">
                  <a href="/blog" className="hover:text-[#FF0000] transition-colors" data-id="element-2425" data-mp="1q3svh3ask67y">
                    Blog
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-2426" data-mp="244dfg2sg0831">
              <h4 className="font-bold mb-6 text-xs uppercase tracking-widest text-white" data-id="element-2427" data-mp="242siy7mkif2j">
                Legal
              </h4>
              <ul className="space-y-4 text-sm font-medium text-gray-400" data-id="element-2428" data-mp="17ffh6alhhs14">
                <li data-id="element-2429" data-mp="1bfzepf9yyxns">
                  <a href="/privacy" className="hover:text-[#FF0000] transition-colors" data-id="element-2430" data-mp="1bffv7u4o817n">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-2431" data-mp="npll3kbqkqr3">
                  <a href="/terms" className="hover:text-[#FF0000] transition-colors" data-id="element-2432" data-mp="nq55d7ouzr8a">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-2433" data-mp="l3umln0t5hco">
                  <a href="mailto:support@toxicdetector.com" className="hover:text-[#FF0000] transition-colors" data-id="element-2434" data-mp="l4e5b5ya89rr">
                    Contact Support
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Blog Posts — SEO Internal Links */}
        <div className="mb-12" data-id="element-2435" data-mp="26kznvw9xlqo">
          <h4 className="font-bold mb-6 text-xs uppercase tracking-widest text-white" data-id="element-2436" data-mp="27mdu98l6ocm">
            Latest Articles
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-2437" data-mp="3olvzwbp1nka8">
            <a href="/blog/7-signs-of-gaslighting" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2438" data-mp="3ojte63uxcdbb">
              7 Signs of Gaslighting in Your Relationship
            </a>
            <a href="/blog/is-your-ex-covert-narcissist" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2439" data-mp="3alla7bzh0bqn">
              Is Your Ex a Covert Narcissist?
            </a>
            <a href="/blog/how-to-spot-passive-aggressive-texts" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2440" data-mp="351npnjxazcgn">
              How to Spot Passive-Aggressive Texts
            </a>
            <a href="/blog/narcissism-and-gaslighting-explained" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2441" data-mp="3jp0h1p9skcey">
              Narcissism & Gaslighting Explained
            </a>
            <a href="/blog/why-some-people-drain-you" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2442" data-mp="39ye648d0sa2l">
              Why Some People Drain You
            </a>
            <a href="/blog/emotional-drain-part-2" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2443" data-mp="6gdsacks9ah2">
              Emotional Drain: Part 2
            </a>
          </div>
        </div>

        {/* Language Selector — SEO Internal Links */}
        <div className="mb-12" data-id="element-2444" data-mp="1qyeuf737o3p7">
          <h4 className="font-bold mb-4 text-xs uppercase tracking-widest text-white" data-id="element-2445" data-mp="24rnyqtcaxz0v">
            Available Languages
          </h4>
          <div className="flex flex-wrap gap-3" data-id="element-2446" data-mp="20rlwahyqt1kj">
            <a href="/" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="en" data-id="element-2447" data-mp="1d0qbi4spf6ms">
              English
            </a>
            <a href="/pt" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="pt" data-id="element-2448" data-mp="1m2puh2na4ksd">
              Português
            </a>
            <a href="/es" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="es" data-id="element-2449" data-mp="2sggscj5gbusb">
              Español
            </a>
            <a href="/ja" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="ja" data-id="element-2450" data-mp="3ljrjgbj6ru7j">
              日本語
            </a>
            <a href="/ko" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="ko" data-id="element-2451" data-mp="3vc74jhps4ywn">
              한국어
            </a>
            <a href="/de" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="de" data-id="element-2452" data-mp="d36klnk9qhi5">
              Deutsch
            </a>
            <a href="/fr" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="fr" data-id="element-2453" data-mp="27cv2vmtsz5cg">
              Français
            </a>
            <a href="/hi" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="hi" data-id="element-2454" data-mp="1tkx4o71mqtv2">
              हिन्दी
            </a>
            <a href="/id" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="id" data-id="element-2455" data-mp="2lcw5p7tmomuk">
              Bahasa Indonesia
            </a>
          </div>
        </div>

        {/* Liability Disclosure - Collapsible */}
        <div className="bg-[#0A0A0A] border border-gray-800 rounded-xl mb-8 overflow-hidden" data-id="element-2456" data-mp="10vzwiwr4udg1">
          <button onClick={() => setIsDisclosureOpen(prev => !prev)} className="w-full flex items-center justify-between p-6 text-left group cursor-pointer" data-id="element-2457" data-mp="3feoqnqvxbw5k">
            <h4 className="text-[#FF0000] text-xs font-bold uppercase tracking-widest" data-id="element-2458" data-mp="3o8bl9doeatd6">
              Liability & Usage Disclosure
            </h4>
            <motion.div animate={{
            rotate: isDisclosureOpen ? 180 : 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-2459" data-mp="3jfs6wehvvu7b">
              <ChevronDown size={16} className="text-gray-500 group-hover:text-gray-300 transition-colors" data-id="element-2460" data-mp="b1rxfg22v4ys" />
            </motion.div>
          </button>
          <AnimatePresence initial={false} data-id="element-2461" data-mp="2csd7wxm6pl65">
            {isDisclosureOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-2462" data-mp="28r1c2acpw3pi">
                <div className="px-6 pb-6 text-xs text-gray-500 font-mono leading-relaxed space-y-2" data-id="element-2463" data-mp="1eylwd167ozv2">
                  <p data-id="element-2464" data-mp="1jygo16xt9th6">
                    ToxicDetector.ai is an AI-powered linguistic analysis tool
                    designed for educational, entertainment, and self-validation
                    purposes only.
                  </p>
                  <p data-id="element-2465" data-mp="1axs98a0lfp38">
                    <strong className="text-gray-400" data-id="element-2466" data-mp="1azd2lwb691zi">
                      Not Clinical Advice:
                    </strong>{' '}
                    While our algorithms are trained on behavioral patterns,
                    ToxicDetector does not provide medical, psychological, or
                    psychiatric diagnoses. It is not a substitute for
                    professional therapy or mental health counseling.
                  </p>
                  <p data-id="element-2467" data-mp="2tx9ddiiahute">
                    <strong className="text-gray-400" data-id="element-2468" data-mp="2twq3mp2smcqg">
                      Not Legal Evidence:
                    </strong>{' '}
                    The "Forensic Dossier" and "Toxicity Scores" are digital
                    interpretations of text patterns and are not certified for
                    use as primary evidence in legal proceedings or divorce
                    litigation.
                  </p>
                  <p data-id="element-2469" data-mp="3cszez4mb8p6r">
                    <strong className="text-gray-400" data-id="element-2470" data-mp="37vzd75whu8lg">Data Privacy:</strong> We
                    utilize AES-256 encryption. By using this tool, you confirm
                    you have the right to analyze the uploaded text.
                    ToxicDetector is not responsible for interpersonal outcomes
                    resulting from the use of our reports.
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8" data-id="element-2471" data-mp="grbb6fb69m76">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs font-mono text-gray-600 uppercase tracking-wide" data-id="element-2472" data-mp="ln05a34faaw3">
            <p data-id="element-2473" data-mp="up9hqyj94ec4">
              © {new Date().getFullYear()} ToxicDetector. All rights reserved.
            </p>
            <div className="flex gap-8" data-id="element-2474" data-mp="znug0sey0nxx">
              <a href="/privacy" className="hover:text-white transition-colors" data-id="element-2475" data-mp="zmrp4khmeli0">
                Privacy
              </a>
              <a href="/terms" className="hover:text-white transition-colors" data-id="element-2476" data-mp="14h5o0wvhrarf">
                Terms
              </a>
              <a href="mailto:support@toxicdetector.com" className="hover:text-white transition-colors" data-id="element-2477" data-mp="1ed8tabln3pil">
                Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}